export default __webpack_public_path__ + "static/media/ocean.4ed83b77.mp3";